<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div id="kt_app_content" class="app-content flex-column-fluid">
    <!--begin::Content container-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
        <!--begin::Toolbar container-->
        <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
            <!--begin::Page title-->
            <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                <!--begin::Title-->
                <div class="d-flex align-items-center">
                    <h1 class="page-heading"><svg width="29" height="28" viewBox="0 0 29 28" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_339_1102)">
                                <path
                                    d="M23.7844 8.7727C23.7311 8.08605 23.1655 7.5484 22.4809 7.52574C21.5601 7.49553 20.6795 6.99702 20.1992 6.13527C19.7128 5.27147 19.7422 4.25522 20.1904 3.44635C20.5299 2.83317 20.3345 2.06618 19.7641 1.66037C19.318 1.34314 18.8432 1.06367 18.3445 0.826092C17.7105 0.523966 16.9468 0.729961 16.5813 1.33147C16.1017 2.12043 15.2382 2.64709 14.2483 2.64709C13.2585 2.64709 12.3956 2.12043 11.9154 1.33147C11.5492 0.729274 10.7861 0.523279 10.1522 0.826092C9.65349 1.06367 9.17939 1.34314 8.73261 1.66037C8.16218 2.06618 7.9668 2.83248 8.30632 3.44635C8.75447 4.25591 8.78384 5.27215 8.29744 6.13527C7.81719 6.99702 6.93661 7.49484 6.01573 7.52574C5.33122 7.5484 4.76557 8.08605 4.71229 8.7727C4.69316 9.01715 4.68359 9.26434 4.68359 9.51359C4.68359 9.76285 4.69316 10.01 4.71229 10.2545C4.76557 10.9411 5.33122 11.4788 6.01573 11.5014C6.93661 11.5317 7.81719 12.0295 8.29744 12.8919C8.78384 13.7557 8.75447 14.772 8.30632 15.5808C7.9668 16.194 8.16218 16.961 8.73261 17.3668C9.1787 17.684 9.65349 17.9635 10.1522 18.2011C10.7861 18.5032 11.5492 18.2972 11.9154 17.6957C12.395 16.9068 13.2585 16.3801 14.2483 16.3801C15.2382 16.3801 16.101 16.9061 16.5813 17.6957C16.9475 18.2979 17.7105 18.5039 18.3445 18.2011C18.8432 17.9635 19.318 17.684 19.7641 17.3668C20.3345 16.961 20.5299 16.1947 20.1904 15.5808C19.7422 14.7713 19.7128 13.755 20.1992 12.8919C20.6795 12.0302 21.5601 11.5323 22.4809 11.5014C23.1655 11.4788 23.7311 10.9411 23.7844 10.2545C23.8035 10.01 23.8131 9.76285 23.8131 9.51359C23.8131 9.26434 23.8035 9.01715 23.7844 8.7727ZM14.249 12.9468C12.3629 12.9468 10.8333 11.4094 10.8333 9.51359C10.8333 7.61775 12.3629 6.08034 14.249 6.08034C16.1352 6.08034 17.6648 7.61775 17.6648 9.51359C17.6648 11.4094 16.1352 12.9468 14.249 12.9468Z"
                                    fill="#265D91" />
                                <path
                                    d="M10.7591 19.0264C10.4571 19.0264 10.1497 18.9598 9.85935 18.8218C9.32991 18.5691 8.81824 18.2684 8.33798 17.9271C7.47312 17.3126 7.20328 16.161 7.70881 15.2471C8.05994 14.614 8.05721 13.8594 7.70266 13.2297C7.35152 12.6001 6.71346 12.2114 5.99342 12.1874C4.95436 12.1531 4.11135 11.3449 4.03074 10.308C4.01093 10.045 4 9.78 4 9.51289C4 9.24578 4.01093 8.98142 4.03074 8.71912C4.11135 7.68091 4.95504 6.87341 5.99274 6.83839C6.71346 6.81504 7.35152 6.4264 7.70129 5.7988C8.05721 5.16639 8.05926 4.41245 7.70881 3.77936C7.20328 2.86543 7.47312 1.71323 8.33798 1.09936C8.81755 0.758097 9.32923 0.457344 9.85867 0.205343C10.8192 -0.251966 11.9539 0.0776265 12.4977 0.973705C12.8734 1.59169 13.5272 1.96042 14.2479 1.96042C14.9686 1.96042 15.6224 1.59169 15.9981 0.973019C16.5426 0.0776265 17.6793 -0.251966 18.6364 0.204657C19.1659 0.457344 19.6775 0.758097 20.1578 1.09936C21.0227 1.71391 21.2925 2.86543 20.787 3.77936C20.4358 4.41245 20.4386 5.16708 20.7931 5.79674C21.1443 6.4264 21.7823 6.81504 22.5024 6.83907C23.5414 6.87341 24.3844 7.68159 24.465 8.71844C24.4848 8.98142 24.4958 9.24647 24.4958 9.51358C24.4958 9.78069 24.4848 10.045 24.465 10.3073C24.3844 11.3456 23.5407 12.1531 22.503 12.1881C21.7823 12.2114 21.1443 12.6001 20.7945 13.2277C20.4386 13.8601 20.4365 14.614 20.787 15.2471C21.2925 16.161 21.0227 17.3132 20.1578 17.9271C19.6782 18.2684 19.1665 18.5691 18.6371 18.8211C17.6746 19.2791 16.5419 18.9482 15.9974 18.0534C15.6224 17.4348 14.9686 17.066 14.2479 17.066C13.5272 17.066 12.8734 17.4348 12.4984 18.0528C12.1185 18.6762 11.4531 19.0264 10.7591 19.0264ZM10.7591 1.37402C10.6539 1.37402 10.5459 1.39737 10.4434 1.44612C9.98574 1.66448 9.54237 1.9254 9.12634 2.22066C8.83258 2.4294 8.73694 2.81256 8.90295 3.11194C9.48704 4.16663 9.48294 5.4232 8.89133 6.47378C8.31612 7.50581 7.22241 8.17324 6.03714 8.21169C5.70172 8.22268 5.4189 8.49253 5.39294 8.82624C5.37586 9.05284 5.36629 9.28218 5.36629 9.51358C5.36629 9.74498 5.37586 9.97501 5.39294 10.2023C5.4189 10.5346 5.70172 10.8045 6.03783 10.8155C7.22172 10.8546 8.31612 11.5213 8.8927 12.5561C9.48226 13.6033 9.48704 14.8598 8.90295 15.9152C8.73694 16.2146 8.83258 16.5978 9.12634 16.8065C9.54169 17.1018 9.98573 17.3627 10.4441 17.581C10.7714 17.7376 11.1539 17.6318 11.3322 17.3373C11.9573 16.308 13.0469 15.6934 14.2479 15.6934C15.4489 15.6934 16.5385 16.3087 17.1636 17.338C17.3425 17.6325 17.7237 17.7362 18.0523 17.581C18.51 17.3627 18.9534 17.1018 19.3694 16.8065C19.6632 16.5978 19.7588 16.2146 19.5928 15.9152C19.0087 14.8605 19.0128 13.604 19.6044 12.5534C20.1797 11.5213 21.2734 10.8539 22.4586 10.8155C22.7941 10.8045 23.0769 10.5346 23.1028 10.2009C23.1199 9.97432 23.1295 9.74498 23.1295 9.51358C23.1295 9.28218 23.1199 9.05215 23.1028 8.82487C23.0769 8.49253 22.7941 8.22268 22.458 8.21169C21.2741 8.17255 20.1797 7.50581 19.6031 6.47103C19.0135 5.42389 19.0087 4.16732 19.5928 3.11194C19.7588 2.81256 19.6632 2.4294 19.3694 2.22066C18.9541 1.9254 18.51 1.66448 18.0517 1.44612C17.7244 1.29025 17.3425 1.39531 17.1642 1.6892C16.5385 2.71917 15.4482 3.33372 14.2479 3.33372C13.0476 3.33372 11.9573 2.71917 11.3315 1.6892C11.2086 1.48663 10.99 1.37402 10.7591 1.37402Z"
                                    fill="#265D91" />
                            </g>
                            <defs>
                                <filter id="filter0_d_339_1102" x="0" y="0" width="28.4961" height="27.0264"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset dy="4" />
                                    <feGaussianBlur stdDeviation="2" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_339_1102" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_339_1102"
                                        result="shape" />
                                </filter>
                            </defs>
                        </svg>

                        Paramètres
                    </h1>

                </div>
                <!--end::Title-->
                <!--begin::Breadcrumb-->
                <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                    <!--begin::Item-->
                    <li class="breadcrumb-item text-muted">
                        <a  class="text-muted"  routerLink="/">Accueil</a>
                    </li>
                    <!--end::Item-->
                    <!--begin::Item-->
                    <li class="breadcrumb-item">
                        <span class="bullet bg-gray-400 w-5px h-2px"></span>
                    </li>
                    <!--end::Item-->
                    <!--begin::Item-->
                    <li class="breadcrumb-item text-muted"><a class="text-muted" routerLink="/acceuil/parametres/parametre-abonnement">Offres</a></li>
                    <!--end::Item-->
                    <li class="breadcrumb-item">
                        <span class="bullet bg-gray-400 w-5px h-2px"></span>
                    </li>
                    <!--end::Item-->
                    <!--begin::Item-->
                    <li class="breadcrumb-item text-muted">Liste des abonnements</li>
                    <!--end::Item-->
                </ul>
                <!--end::Breadcrumb-->
            </div>
            <!--end::Page title-->
            <!--begin::Actions-->

            <!--end::Actions-->
        </div>
        <!--end::Toolbar container-->
    </div>
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
            <div class="title d-flex align-items-baseline">
                <h4>Liste des abonnements</h4>
                <div *ngIf="nameOffer" class=" pack d-flex">
                    <span>-</span>
                    <p class="">{{nameOffer}}</p>
                </div>
            </div>
            <!--begin::Card header-->
            <div class="card-header border-0 pt-6 mb-4">
                <!--begin::Card title-->

                <div class="card-title">
                    <div class="input-group mb-3">
                        <input type="text" data-kt-customer-table-filter="search"  [(ngModel)]="searchElement"
                            class="form-control form-control-solid ps-15" placeholder="Rechercher" (keyup.enter)="applyFilter()"/>
                            <div class="input-group-append">
                            <svg  width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                    fill="#7E7C7C" />
                            </svg>

                            <button  class="input-group-text cursor-pointer" id="basic-addon2"  (click)="applyFilter()" ><span>Rechercher</span>
                            </button>
                        </div>
                    </div>
                </div>
                <!--begin::Card title-->
                <!--begin::Card toolbar-->
                <div class="card-toolbar">
                    <!--begin::Toolbar-->
                    <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base">
                        <!--begin::Filter-->

                        <!--end::Filter-->
                        <!--begin::Export-->

                        <!--end::Export-->
                        <!--begin::Add customer-->
                        <!--end::Add customer-->
                    </div>
                    <!--end::Toolbar-->
                    <!--begin::Group actions-->

                    <!--end::Group actions-->
                </div>
                <!--end::Card toolbar-->
            </div>
            <!--end::Card header-->
            <!--begin::Card body-->
            <div class="card-body pt-0">
                <!--begin::Table-->
                <div class="table-responsive">
                    <table class="table align-middle fs-6 gy-5" id="kt_customers_table">
                        <thead>
                            <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">

                                <th class="min-w-125px"><span>Nom ESN</span></th>
                                <th class="min-w-125px"><span>Date début</span> </th>
                                <th class="min-w-125px"><span>Compte Bancaire</span></th>
                                <th class="min-w-125px"><span>Statut</span></th>
                                <th class="min-w-125px"><span>Facture</span></th>
                                <th class="min-w-125px"><span>ACTION</span></th>
                            </tr>
                        </thead>
                        <tbody class=" text-gray-600">
                            <tr *ngFor="let data of listAbonnement">

                                <td class="fw-bold">
                                    <a (click)="profilEsnNavigation(data.company_id)" class="first-td">{{data.Company_name?data.Company_name:'---'}}</a>
                                </td>

                                <td>
                                    <span>{{!data?.start_date?'---':data?.start_date | formatDate}}</span>
                                </td>
                                <td>
                                    <span>--- </span>
                                </td>
                                <td>
                                    <span>
                                        <div [ngClass]="data.state=='1'?'badge badge-success':'badge badge-danger'" ><svg width="6"
                                                height="6" viewBox="0 0 6 6" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                            </svg>{{data.state=='1'?'Activé':'Désactivé'}}</div>
                                    </span>
                                </td>
                                <td>
                                    <a class="cursor-pointer"  (click)="exportInvoice(data.facture_id)"><i class="fa-solid fa-cloud-arrow-down"
                                            style="color:#265D91;font-size: 20px;"></i></a>
                                </td>
                                <td>
                                    <!-- begin menu action -->
                                    <div class="tools">
                                        <div class="dropdown">
                                            <button  
                                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                                type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                        transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                        transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                        transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                                </svg>
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <a  (click)="profilEsnNavigation(data.company_id)"
                                                    class="dropdown-item cursor-pointer">Voir profil ESN</a>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- end menu action -->
                                </td>

                            </tr>


                        </tbody>
                        <!--end::Table body-->
                    </table>
                </div>
               
                <div class="alert alert-warning text-center mt-5" role="alert" *ngIf="!listAbonnement?.length">
                    <img src="/assets/media/logos/logo-no-data.png" alt="" class="mb-5">
                    <span class="empty-list">
                     La liste est vide
                 </span>
                 </div>


                <div class="pagination" *ngIf="listAbonnement && listAbonnement?.length">
                    <app-pagination [data]="listAbonnement" [currentPageList]="currentPage" [lengthData]="totalItems" (setPages)="getItems($event)">
                    </app-pagination>
                </div>
                <!--end::Table-->
            </div>
            <!--end::Card body-->
        </div>
        <!--end::Card-->
        <!--begin::Modals-->
        <!--begin::Modal - Customers - Add-->
        <div class="modal fade" id="kt_modal_add_customer" tabindex="-1" aria-hidden="true">
            <!--begin::Modal dialog-->
            <div class="modal-dialog modal-dialog-centered mw-650px">
                <!--begin::Modal content-->
                <div class="modal-content">
                    <!--begin::Form-->
                    <form class="form" action="#" id="kt_modal_add_customer_form"
                        data-kt-redirect="../../demo1/dist/apps/customers/list.html">
                        <!--begin::Modal header-->
                        <div class="modal-header" id="kt_modal_add_customer_header">
                            <!--begin::Modal title-->
                            <h2 class="fw-bold">Ajouter offre</h2>
                            <!--end::Modal title-->
                            <!--begin::Close-->
                            <div id="kt_modal_add_customer_close" data-bs-dismiss="modal"
                                class="btn btn-icon btn-sm btn-active-icon-primary">
                                <i class="ki-duotone ki-cross fs-1">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                </i>
                            </div>
                            <!--end::Close-->
                        </div>
                        <!--end::Modal header-->
                        <!--begin::Modal body-->
                        <div class="modal-body py-10 px-lg-17">
                            <!--begin::Scroll-->
                            <div class="scroll-y me-n7 pe-7 tools" id="kt_modal_add_customer_scroll"
                                data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}"
                                data-kt-scroll-max-height="auto"
                                data-kt-scroll-dependencies="#kt_modal_add_customer_header"
                                data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                                <!--begin::Input group-->
                                <div class="row">
                                    <div class="col-6 mb-3">
                                        <!--begin::Label-->
                                        <label class="required fs-6 fw-semibold mb-2">Nom de l’offre</label>
                                        <!--end::Label-->
                                        <!--begin::Input-->
                                        <input type="text" class="form-control form-control-solid"
                                            placeholder="Ajouter une offre" name="name" />
                                        <!--end::Input-->
                                    </div>
                                    <div class="col-6 mb-3">
                                        <!--begin::Label-->
                                        <label class="required fs-6 fw-semibold mb-2">Date début</label>
                                        <!--end::Label-->
                                        <!--begin::Input-->
                                        <input type="date" class="form-control form-control-solid" placeholder=""
                                            name="name" />
                                        <!--end::Input-->
                                    </div>
                                    <div class="col-6 mb-3">
                                        <!--begin::Label-->
                                        <label class="required fs-6 fw-semibold mb-2">Date fin</label>
                                        <!--end::Label-->
                                        <!--begin::Input-->
                                        <input type="date" class="form-control form-control-solid" placeholder=""
                                            name="name" />
                                        <!--end::Input-->
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label for="Pays" class="required form-label">Période d’essai</label>
                                        <select data-control="select2" data-placeholder="Select a format"
                                            data-hide-search="true" name="format" class="form-select style mb-3">
                                            <option value="1">30 jours</option>
                                            <option value="pdf">45 jours</option>
                                            <option value="cvs">10jours</option>
                                        </select>
                                    </div>
                                    <div class="col-6 mb-3">
                                        <!--begin::Label-->
                                        <label class="required fs-6 fw-semibold mb-2">Prix</label>
                                        <!--end::Label-->
                                        <!--begin::Input-->
                                        <input type="text" class="form-control form-control-solid" placeholder="0.00 €"
                                            name="name" />
                                        <!--end::Input-->
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label for="Pays" class="required form-label">Dédié à</label>
                                        <select data-control="select2" data-placeholder="Select a format"
                                            data-hide-search="true" name="format" class="form-select style mb-3">
                                            <option value="ESN">ESN</option>
                                            <option value="Client final">Client final</option>
                                            <option value="Candidat">Candidat</option>
                                        </select>
                                    </div>
                                    <div class="col-6 mb-3">
                                        <!--begin::Label-->
                                        <label class="required fs-6 fw-semibold mb-2">Nombre d’intervenant</label>
                                        <!--end::Label-->
                                        <!--begin::Input-->
                                        <input type="text" class="form-control form-control-solid" placeholder="8"
                                            name="name" />
                                        <!--end::Input-->
                                    </div>
                                    <div class="col-6 mb-3">
                                        <!--begin::Label-->
                                        <label class="required fs-6 fw-semibold mb-2">Nombre de consultants</label>
                                        <!--end::Label-->
                                        <!--begin::Input-->
                                        <input type="text" class="form-control form-control-solid" placeholder="5"
                                            name="name" />
                                        <!--end::Input-->
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 mb-3">
                                        <label for="Pays" class="required form-label">Permission</label>
                                        <select data-control="select2" data-placeholder="Select a format"
                                            multiple="true" data-hide-search="true" name="format"
                                            class="form-select style mb-3">
                                            <option value="Contacter client">Contacter client</option>
                                            <option value="Ajouter offre d'emploi">Ajouter offre d'emploi</option>
                                        </select>
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label for="Pays" class="required form-label">Compte bancaire</label>
                                        <select data-control="select2" data-placeholder="Select a format"
                                            data-hide-search="true" name="format" class="form-select style mb-3">
                                            <option value="1">558696678651656</option>
                                            <option value="2">001122445588778</option>
                                            <option value="3">111122222223333</option>
                                        </select>
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label class="required fs-6 fw-semibold mb-2">Nombre de CV à télécharger</label>
                                        <input type="text" class="form-control form-control-solid" placeholder="5"
                                            name="name" />
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label class="required fs-6 fw-semibold mb-2">Nombre de profils à
                                            exporter</label>
                                        <input type="text" class="form-control form-control-solid" placeholder="5"
                                            name="name" />
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label class="required fs-6 fw-semibold mb-2">Nombre d’offre d’emploi</label>
                                        <input type="text" class="form-control form-control-solid" placeholder="5"
                                            name="name" />
                                    </div>

                                </div>


                            </div>
                            <!--end::Scroll-->
                        </div>
                        <!--end::Modal body-->
                        <!--begin::Modal footer-->
                        <div class="modal-footer ">
                            <!--begin::Button-->
                            <button type="reset" data-bs-dismiss="modal" id="kt_modal_add_customer_cancel"
                                class="footer-btn annuler me-3">Annuler</button>
                            <!--end::Button-->
                            <!--begin::Button-->
                            <button type="submit" id="kt_modal_add_customer_submit" class="footer-btn confirmer">
                                <span class="indicator-label">Confirmer </span>
                                <span class="indicator-progress">Please wait...
                                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                            </button>
                            <!--end::Button-->
                        </div>
                        <!--end::Modal footer-->
                    </form>
                    <!--end::Form-->
                </div>
            </div>
        </div>
        <!--end::Modal - Customers - Add-->
        <!--begin::Modal - Adjust Balance-->

        <!--end::Modal - New Card-->
        <!--end::Modals-->
    </div>
    <!--end::Content container-->
</div>
<!-- edit_detail offer modal -->
<div class="modal fade" id="update_subscription" tabindex="-1" aria-hidden="true">
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-650px">
        <!--begin::Modal content-->
        <div class="modal-content">
            <!--begin::Modal header-->
            <div class="modal-header">
                <!--begin::Modal title-->
                <h2 class="">Modifier abonnement</h2>
                <!--end::Modal title-->
                <!--begin::Close-->
                <div id="kt_customers_export_close" data-bs-dismiss="modal"
                    class="btn btn-icon btn-sm btn-active-icon-primary">
                    <i class="ki-duotone ki-cross fs-1">
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </i>
                </div>
                <!--end::Close-->
            </div>
            <!--end::Modal header-->
            <!--begin::Modal body-->
            <div class="modal-body scroll-y mx-5 mx-xl-15 my-7 tools">
                <!--begin::Form-->
                <form id="kt_customers_export_form " class="form" action="#">
                    <!--begin::Input group-->
                    <div class="fv-row mb-5">
                        <!--begin::Label-->

                        <div class="mb-5">
                            <label for="intervenant" class=" form-label">Nom ESN</label>
                            <input type="text" class="form-control mb-3" placeholder="esn" />
                        </div>
                        <div class="mb-5">
                            <label for="consultant" class=" form-label">Date début</label>
                            <input type="date" class="form-control mb-3" placeholder="jj/mm/aaaa" />
                        </div>
                        <div class="mb-5">
                            <label for="consultant" class=" form-label">Date fin</label>
                            <input type="date" class="form-control mb-3" placeholder="jj/mm/aaaa" />
                        </div>
                        <div class="mb-5">
                            <label for="prix" class=" form-label">Période d'essai</label>
                            <input type="text" class="form-control   mb-3" placeholder="30" />
                        </div>
                        <div class="mb-5">
                            <label for="prix" class=" form-label">Compte bancaire</label>
                            <input type="text" class="form-control   mb-3" placeholder="30" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="reset" id="kt_customers_export_cancel" data-bs-dismiss="modal"
                            class="footer-btn annuler me-3" (click)="clearData()">Annuler</button>
                        <button type="submit" id="kt_customers_export_submit" class="footer-btn confirmer ">
                            <span class="indicator-label">Confirmer</span>
                            <span class="indicator-progress">Please wait...
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>